const isTransmissionAuto = ({ acriss }) => {
  if (!acriss) return ''

  const transType = acriss?.charAt(2)

  if (
    transType === 'A' ||
    transType === 'B' ||
    transType === 'D' ||
    transType === 'Z'
  )
    return true

  return false
}

export default isTransmissionAuto
